import React, { Fragment } from 'react';

import Type, { Title } from '@nerdwallet/react-typography';
import Button from '@nerdwallet/react-button';

const AboutUsPage = () => (
  <Fragment>
    <div id="about-us-page">
      <div className="about-us">
        <div id="group1" className="about-us__group">
          <div id="intro">
            <div className="intro__cont">
              <div className="intro__copy">
                <Title size="large" component="h1">
                  NerdWallet&apos;s objective advice, expert info and helpful
                  tools help you make smart money moves.
                </Title>
              </div>
            </div>
          </div>
        </div>
        <div id="group2" className="about-us__group">
          <div id="cerealbox">
            <div className="cerealbox__cont">
              <div className="cerealbox__copy">
                <Title component="h2" className="cerealbox__heading">
                  We&apos;re thinking way outside the box
                </Title>
                <Type size="2">
                  We all face financial choices at some point. And for a long
                  time, people have been forced to navigate some pretty
                  important decisions without a whole lot of clarity.
                </Type>
                <Type size="2">
                  In 2009, we set out to change all that. And today, it&apos;s
                  easier than ever to find and shop the right credit cards and
                  mortgage rates, tap into spending insights, earn extra cash
                  back and so much more. All with NerdWallet.
                </Type>
              </div>
            </div>
          </div>
        </div>
        <div id="group3" className="about-us__group">
          <div id="milk">
            <div className="milk__cont">
              <div className="milk__copy">
                <Title>No secret ingredients</Title>
                <Type size="2">
                  It&apos;s simple: You&apos;re our first priority. We believe
                  everyone should be able to make financial decisions with
                  confidence. And, we&apos;re proud that the guidance we offer,
                  the information we provide and the tools we create are
                  objective, independent, straightforward and free.
                </Type>
                <Type size="2">
                  So how do we make money? In some cases, we receive
                  compensation when someone clicks to apply or gets approved for
                  a financial product through our site. However, this in no way
                  affects our recommendations or advice. We&apos;re committed to
                  helping you make your smartest money move.
                </Type>
              </div>
            </div>
          </div>
        </div>
        <div id="group4" className="about-us__group">
          <div id="spoon">
            <div className="spoon__cont">
              <div className="spoon__copy">
                <Title className="spoon__heading">
                  And people are dishing out the praise
                </Title>
                <Type size="2">
                  Those who know a thing or two about finance have some great
                  things to say about NerdWallet.
                </Type>
                <ul className="spoon__img">
                  <li className="logo-gma logo-img">&nbsp;</li>
                  <li className="logo-nyt logo-img">&nbsp;</li>
                  <li className="logo-today logo-img">&nbsp;</li>
                  <li className="logo-mashable logo-img">&nbsp;</li>
                  <li className="logo-ap logo-img">&nbsp;</li>
                  <li className="logo-realsimple logo-img">&nbsp;</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div id="group5" className="about-us__group">
          <div id="bowl">
            <div className="bowl__cont">
              <div className="bowl__copy">
                <Title>Ready to dig in?</Title>
                <div className="about-btn">
                  <Button
                    primary
                    href="https://www.nerdwallet.com/home/signin?flow=basic&trk_source=nw_about_us&trk_content=cta&trk_destination=nw_home"
                    className="about-btn__btn"
                  >
                    LET&apos;S DO IT
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Fragment>
);

AboutUsPage.displayName = 'About Us';

AboutUsPage.propTypes = {};

export default AboutUsPage;
